<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                date: '',
                user_id: '',
                company_id: '',
                subtotal:0,
                retention:0,
                amount: 0,
                payment_id: '',
                bank_account_id: '',
            },
            advance:{
                user_id:0,
                user:{
                    name:'',
                    last_name:''
                }
            },
            type_id:'',
            submitable: false,
            approved: false,
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.user_id = '';
            const now = new Date();
            this.form.date = now.toISOString().slice(0, 10);
            this.form.company_id = '';
            this.form.subtotal = 0;
            this.form.retention = 0;
            this.form.amount = 0;
            this.form.payment_id = '';
            this.form.bank_account_id = '';
            this.type_id='';
            this.catalogue.companies_users=[];
            this.advance={
                user_id:0,
                user:{
                    name:'',
                    last_name:''
                }
            },
            this.send = false;
            this.errors = {};
            this.$modal.hide('addAdvance');
        },
        updateTotal(change=true) {
            if(this.prop_edit){
                this.errors=[];
                this.submitable=true;
                let vm=this,
                amount=this.form.subtotal,
                retention=this.form.retention,
                total=0;
                if(change){
                    if(this.type_id==1 && parseFloat(amount)>0){
                        let tax=this.catalogue.share_taxes.find(a=> a.min<=amount && (a.max>=amount || (a.max??0) == 0) );
                        retention=parseFloat((amount-tax.min)*tax.percentage+tax.quota);
                    }else{
                        let rule=this.catalogue.rules_shares.find(a=> a.id == vm.type_id);
                        retention=rule?(rule.type==1?parseFloat(amount)*rule.value:rule.value):0;
                    }
                }
                if(retention>amount){
                    this.errors.retention=['La Retención debe ser menor o igual al Remanente'];
                    this.submitable=false;
                }
                this.form.retention=retention;
                total=parseFloat(parseFloat(this.form.subtotal)-parseFloat(this.form.retention)).toFixed(2);
                this.form.amount=total;
                // if(partner.payment==2&&partner.bank_accounts.length==0){
                //     partner.payment=5;
                //     vm.errorNotificationMessage('No se puede seleccionar el tipo de pago Transacción si no se cuenta con Cuentas Bancarias asociadas.');
                // }else if(partner.payment!=2&&partner.bank_accounts.length>0){
                //     partner.bank_account=-1;
                // }
                if(total<0) this.submitable=false;
            }
        },
        async saveAdvance() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id);
            data_form.append('user_id', this.form.user_id);
            data_form.append('date', this.form.date);
            data_form.append('company_id', this.form.company_id);
            data_form.append('retention', this.form.retention);
            data_form.append('amount', this.form.amount);
            data_form.append('payment_id', this.form.payment_id);
            data_form.append('bank_account_id', this.form.bank_account_id);

            let _endpoint = '/partners/advances';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/partners/advances/${this.form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    Event.$emit('event-load-advances');
                    this.closedModal();
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                    this.errorNotificationMessage(this.errors[Object.keys(this.errors)[0]][0]);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
			errorNotificationMessage: 'alert/errorMessage',
        }),
    },
    watch: {
        'form.user_id'(value) {
            if(value==''){
                this.form.companies = [];
                this.catalogue.bank_account_provider=[];
            }else{
                this.catalogue.get_companies_users(value);
                this.catalogue.getBankAccountProvider(value);
            }
        },
        'form.subtotal'() {
            this.updateTotal();
        },
        'type_id'() {
            this.updateTotal();
        },
    },
    mounted() {
		this.catalogue.get_users_profile(8);
        this.catalogue.get_share_taxes();
        this.catalogue.get_rules_shares();
        this.catalogue.get_type_payments_partners();
    },
    created() {
        Event.$on("event-show-addAdvance", async (advance,prop_edit) => {
            if (advance.id) {
                this.advance=advance;
                if(prop_edit){
                    this.load = true;
                    this.form.id = advance.id;
                    this.form.user_id = advance.user_id;
                    this.form.date = advance.date;
                    this.form.company_id = advance.company_id;
                    this.form.subtotal = parseFloat(advance.amount) + parseFloat(advance.retention);
                    this.form.retention = advance.retention;
                    this.form.amount = advance.amount;
                    this.form.payment_id = advance.payment_id;
                    this.form.bank_account_id = advance.bank_account_id;
                    this.company=advance.company;
                }
            }else{
                const now = new Date();
                this.form.date = now.toISOString().slice(0, 10);
            }
            this.$modal.show('addAdvance');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addAdvance" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveAdvance" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" v-if="prop_edit">Agregar Adelanto</h5>
                <h5 class="modal-title" id="exampleModalLabel" v-else>Detalle de Adelanto</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6 mt-3" v-if="prop_edit">
                        <label>Socio</label>
						<select v-model="form.user_id" class="form-control">
							<option value=""> Seleccionar usuario </option>
							<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}</option>
						</select>
                        <div v-if="errors && errors.user_id" class="text-danger">
                            {{ errors.user_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Socio</label>
                        {{ advance.user.name }} {{ advance.user.last_name }}
                    </div>

                    <div class="col-md-6 mt-3" v-if="prop_edit">
                        <label>Fecha</label>
                        <date-picker v-model="form.date" required="required"
                             valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3" v-else>
                        <label>Fecha</label>
                        {{ advance.date | toDateTime }}
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Compañia</label>
                        <div v-if="prop_edit">
                            <select type="text" class="form-control" v-model="form.company_id">
                                <option v-for="(comp, index2) in catalogue.companies_users" :value="comp.id" :key="index2">
                                    {{ comp.name }}</option>
                            </select>
                            <div v-if="errors && errors.company_id" class="text-danger">{{
                                errors.company_id[0] }}</div>
                        </div>
                        <div v-else>
                            {{ advance.company.name }}
                        </div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="prop_edit && !approved">
                        <label>Tipo de Reparto</label>
						<select v-model="type_id" class="form-control">
							<option v-for="(rule, index) in catalogue.rules_shares" :value="rule.id" :key="index">
								{{ rule.name }} ({{ rule.description }})</option>
						</select>
                    </div>
                    <div class="col-md-6 mt-3" v-else>
                    </div>
                    <div class="col-4 mt-3">
                        <label>Monto</label>
                        <div v-if="prop_edit">
                            <money class="form-control" v-model="form.subtotal"></money>
                        </div>
                        <div v-else>
                            {{ parseFloat(advance.amount) +parseFloat(advance.retention) | toCurrency}}
                        </div>
                    </div>
                    <div class="col-4 mt-3">
                        <label>Retenci&oacute;n</label>
                        <div v-if="prop_edit">
                            <money class="form-control" v-model="form.retention" readonly></money>
                            <div v-if="errors && errors.retention" class="text-danger">{{
                                errors.retention[0] }}</div>
                        </div>
                        <div v-else>
                            {{ advance.retention | toCurrency}}
                        </div>
                    </div>
                    <div class="col-4 mt-3">
                        <label>Total</label>
                        <div v-if="prop_edit">
                            <money class="form-control" v-model="form.amount" readonly></money>
                            <div v-if="errors && errors.amount" class="text-danger">{{
                                errors.amount[0] }}</div>
                        </div>
                        <div v-else>
                            {{ advance.amount | toCurrency}}
                        </div>
                    </div>
                    <div class="col-6 mt-3">
                        <label>Tipo de Pago</label>
                        <div v-if="prop_edit">
                            <select v-model="form.payment_id" class="form-control">
                                <option v-for="(payment, index) in catalogue.type_payments" :value="payment.id" :key="index">
                                    {{ payment.name }}</option>
                            </select>
                            <div v-if="errors && errors.payment_id" class="text-danger">{{
                                errors.payment_id[0] }}</div>
                        </div>
                        <div v-else>
                            {{ advance.payment.name }}
                        </div>
                    </div>
                    <div class="col-6 mt-3" v-if="form.payment_id==2">
                        <label>Cuenta bancaria</label>
                        <div v-if="prop_edit">
                            <select v-model="form.bank_account_id" class="form-control">
                                <option v-for="(account, index) in catalogue.bank_account_provider" :value="account.id" :key="index">
                                    {{ account.bank.name }} - {{ account.account_number }}</option>
                            </select>
                            <div v-if="errors && errors.bank_account_id" class="text-danger">{{
                                errors.bank_account_id[0] }}</div>
                        </div>
                        <div v-else>
                            {{ advance.bank_account.bank.name }} - {{ advance.bank_account.account_number }}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send && submitable" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>